"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageOverlay = exports.CustomTag = exports.Subtitle = exports.Title = exports.InfoContainer = exports.Image = exports.ImageContainer = exports.Container = void 0;
const tslib_1 = require("tslib");
const Tag_1 = (0, tslib_1.__importDefault)(require("../../atoms/Tag"));
const theme_1 = require("@monorepo/theme");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.Container = styled_components_1.default.div `
  max-height: 304px;
  grid-template-rows: min-content;
  position: relative;

  @media (min-width: 1920px) {
    max-height: 302px;
    }
`;
exports.ImageContainer = styled_components_1.default.div `
  min-height: 208px;
  background-color: ${theme_1.colors.lightGrey};
  background: url(${(props) => props.background});
  display: flex;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;
exports.Image = styled_components_1.default.img `
  height: 100%;
  width: 100%;
  cursor: pointer;
  position: relative;
  object-fit: contain;
  aspect-ratio: 1 / 1;
`;
exports.InfoContainer = styled_components_1.default.div `
  min-height: 80px;
  background: ${theme_1.colors.white};
  display: flex;
  flex-direction: column;
  padding: 24px;
  margin-bottom: 16px;
  text-align: center;
  gap: 6px;
`;
exports.Title = styled_components_1.default.p `
  font-family: PFDINText;
  text-transform: none;
  font-size: 28px;
  cursor: pointer;
  font-weight: 500;
  line-height: 27.6px;
  text-align: left;
  color:${theme_1.colors.white};
  margin: 24px;

  @media (min-width: 1440px) {
    grid-template-columns: repeat(4, 1fr);
}

@media (min-width: 1920px) {
    grid-template-columns: repeat(6, 1fr);
  }
`;
exports.Subtitle = styled_components_1.default.p `
  font-size: 16px;
  font-family: PFDINText;
  font-weight: 400;
  line-height: 15.5px;
  text-align: left;

  &.location{
    color: #102641CC;
  }

  &.date{
    color:${theme_1.colors.black};
  }
`;
exports.CustomTag = (0, styled_components_1.default)(Tag_1.default) `
  position: absolute;
  margin: 16px;
  font-weight: 500;
  padding: 5px 30px;
`;
exports.ImageOverlay = styled_components_1.default.div `
width: 100%;
background: linear-gradient(0deg, rgba(29, 35, 40, 0.6), rgba(29, 35, 40, 0.6)),
linear-gradient(180deg, rgba(16, 38, 65, 0.5) 0%, rgba(16, 38, 65, 0) 100%);
align-content: flex-start;
`;
